<template>
  <div class="container">
    <div class="banner_wrapper">
      <a-carousel class="banner_carousel" autoplay :autoplaySpeed="3000">
        <div v-for="(data, index) in bannerList" class="banner" :key="index" @click="jumpUrl(data.jumpUrl)">
          <img class="banner_img" :src="data.imageUrl" alt="" />
          <div
            class="headline_content"
            :class="{ hederline_right: data.textPosition == 'right', hederline_left: data.textPosition == 'left' }"
          >
            <div class="headline">{{ data.title }}</div>
            <div class="sub_headline">
              {{ data.describe }}
            </div>
            <div
              v-if="data.dedicateButton == 1"
              class="give_now_btn"
              @click.stop="
                open = true;
                dedicateId = data.bannerId;
              "
            >
              Give Now
              <img src="@/assets/images/arrow_yellow.svg" alt="" />
            </div>
          </div>
        </div>
      </a-carousel>
    </div>
    <div class="ourwork_wrapper">
      <div class="ourwork_title">Public welfare project</div>
      <div class="ourwork_content">
        <div
          v-for="(data, index) in projectList.filter((item) => item.displayHomepage == 1)"
          class="ourwork"
          :key="index"
          @click="linkToDetail('ourwork', data.projectId)"
        >
          <img class="ourwork_img" :src="data.coverUrl" alt="" />
          <div class="ourwork_info">
            <div class="title">{{ data.title }}</div>
            <div class="description">
              {{ data.describe }}
            </div>
            <div class="action_wrapper">
              <span
                class="give_now_btn"
                @click.stop="
                  open = true;
                  dedicateId = data.projectId;
                "
              >
                Give Now
              </span>
              <router-link to="/ourwork" class="more">More >></router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="news_banner_wrapper" v-if="newsBanner.title" @click="linkToDetail('news', newsBanner.newsId)">
      <div class="news_banner_img_content">
        <img class="news_banner_img" :src="newsBanner.coverUrl" alt="" />
      </div>
      <div class="news_banner_tag">
        <div class="title">{{ newsBanner.title }}</div>
        <div class="description">
          {{ newsBanner.description }}
        </div>
      </div>
    </div>
    <div class="world_vision_wrapper">
      <div class="title">Ministry <span style="color:#FF6700">ABC</span>s</div>
      <div class="world_vision_content">
        <div class="sub_word_vision">
          <div class="word_vision main">
            <img class="word_vision_img" src="@/assets/images/world_vision_icon1.svg" alt="" />
            <div class="label"><span style="color:#FFFFFF">A</span>dvanced Leadership Training</div>
          </div>
        </div>
        <div class="sub_word_vision">
          <div class="word_vision" style="margin-bottom: 100px;">
            <img class="word_vision_img" src="@/assets/images/world_vision_icon2.svg" alt="" />
            <div class="label"><span style="color:#FFFFFF">B</span>ible Distribution, Broadcast & Benevolence</div>
          </div>
          <div class="word_vision">
            <img class="word_vision_img" src="@/assets/images/world_vision_icon3.svg" alt="" />
            <div class="label"><span style="color:#FFFFFF">C</span>rusades, Church Planting & Conferences</div>
          </div>
        </div>
      </div>
    </div>
    <div class="news_wrapper">
      <div class="title">News & Stories</div>
      <div class="news_content">
        <div v-for="(data, index) in newsList" class="news" :key="index" @click="linkToDetail('news', data.newsId)">
          <img class="news_img" :src="data.coverUrl" alt="" />
          <div class="news_info">
            <div class="news_title">{{ data.title }}</div>
            <div class="news_description">
              {{ data.description }}
            </div>
            <router-link to="/news" class="more">More >></router-link>
          </div>
        </div>
      </div>
    </div>
    <a-modal class="custom_modal" v-model:open="open" :closable="false" :footer="null">
      <div class="tag">Thank you for your dedication!</div>
      <Payment :dedicateId="dedicateId" />
    </a-modal>
  </div>
</template>

<script setup>
import { LoadingOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import { computed, ref, reactive, onMounted, toRaw, h, nextTick, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';

import { fetchHomeBannerList, fetchHomeProjectList, fetchHomeNewsList, fetchHomeNewsBanner } from '@/api/common';
import Payment from '@/components/Payment.vue';

const route = useRoute();
const router = useRouter();
const store = useStore();
const open = ref(false);
const dedicateId = ref();
const bannerList = ref([]);
const projectList = ref([]);
const newsList = ref([]);
const newsBanner = ref({
  title: '',
  description: '',
  coverUrl: '',
  newsId: '',
});

const jumpUrl = (url) => {
  if (url) {
    window.open(url, '_blank');
  }
};
const getBannerList = () => {
  fetchHomeBannerList().then((res) => {
    if (res.code == 200) {
      bannerList.value = res.data;
    }
  });
};
const getProjectList = () => {
  fetchHomeProjectList().then((res) => {
    if (res.code == 200) {
      projectList.value = res.data;
    }
  });
};
const getNewsList = () => {
  fetchHomeNewsList().then((res) => {
    if (res.code == 200) {
      newsList.value = res.data;
    }
  });
};
const getNewsBanner = () => {
  fetchHomeNewsBanner().then((res) => {
    if (res.code == 200 && res.data) {
      Object.assign(newsBanner.value, res.data);
    }
  });
};
const linkToDetail = (type, id) => {
  router.push(`/${type}/detail/${id}`);
};

onMounted(() => {
  getBannerList();
  getProjectList();
  getNewsList();
  getNewsBanner();
});
</script>

<style lang="less">
.custom_modal {
  .ant-modal-content {
    border-radius: 20px;
    .payment_wrapper {
      margin-top: 80px;
    }
    .tag {
      position: absolute;
      border-radius: 20px 20px 0 0;
      left: 0;
      right: 0;
      top: 0;
      height: 64px;
      background: #05644f;
      font-size: 20px;
      font-weight: bold;
      line-height: 64px;
      color: #ffffff;
      text-align: center;
    }
  }
}
</style>

<style lang="less" scoped>
.container {
  .banner_wrapper {
    margin: 0 auto;
    max-width: 1920px;
    max-height: 500px;
    .banner_carousel {
      .banner {
        position: relative;
        width: 100%;
        padding-bottom: calc(100% * (50 / 192));
        min-height: 200px;
        cursor: pointer;
        .banner_img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .headline_content {
          position: absolute;
          top: 15%;
          width: 575px;
          height: 70%;
          border-radius: 20px;
          opacity: 1;
          padding: 24px;
          background: rgba(255, 255, 255, 0.6);
          &.hederline_left {
            left: 5%;
          }
          &.hederline_right {
            right: 5%;
          }
        }
        .headline {
          font-size: 36px;
          font-weight: 500;
        }
        .sub_headline {
          margin: 32px 0;
          font-size: 16px;
          font-weight: normal;
          line-height: 20px;
          letter-spacing: 0px;
          width: 320px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 4;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .give_now_btn {
          border: 3px solid #f78335;
          padding: 8px 35px;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          color: #f78335;
          font-weight: bold;
          background: #ffffff;
          border-radius: 200px;
          position: absolute;
          right: 32px;
          bottom: 32px;
          cursor: pointer;
        }
        @media (max-width: 1080px) {
          .headline_content {
            width: 80%;
            left: 10% !important;
            padding: 16px;
            margin: 0 auto;
          }
          .headline {
            font-size: 18px;
          }
          .sub_headline {
            margin: 12px 0;
            width: 50%;
            -webkit-line-clamp: 3;
          }
          .give_now_btn {
            bottom: 24px;
            right: 16px;
            padding: 8px 18px;
          }
        }
      }
    }
  }
  .ourwork_wrapper {
    margin: 90px 0;
    .ourwork_title {
      font-size: 32px;
      font-weight: bold;
      text-align: center;
      line-height: 28px;
      margin-bottom: 60px;
      color: #333333;
    }
    .ourwork_content {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      gap: 48px;
      margin: 0 auto;
      width: 1080px;
      .ourwork {
        width: calc(33.33% - 32px);
        border-radius: 16px;
        opacity: 1;
        background: #ffffff;
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
        cursor: pointer;
        @supports (-webkit-transform-style: preserve-3d) {
          &:hover {
            -webkit-transform: translateY(-2px);
            transform: translateY(-2px);
          }
        }
        .ourwork_img {
          width: 100%;
          height: 184px;
          border-top-left-radius: 16px;
          border-top-right-radius: 16px;
        }
        .ourwork_info {
          padding: 20px;
          .title {
            font-size: 18px;
            font-weight: bold;
            margin-bottom: 12px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            height: 40px;
          }
          .description {
            font-size: 14px;
            font-weight: normal;
            line-height: 20px;
            letter-spacing: 0px;
            color: #666666;
            height: 80px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .action_wrapper {
            margin-top: 16px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .give_now_btn {
              border-radius: 100px;
              background: #05644f;
              color: #ffffff;
              font-size: 14px;
              font-weight: bold;
              line-height: 28px;
              padding: 8px 20px;
              display: inline-block;
              cursor: pointer;
            }
            .more {
              margin-left: 24px;
              font-size: 14px;
              font-weight: normal;
              color: #1e7bde;
              cursor: pointer;
              text-decoration: none;
            }
          }
        }
      }
    }
    @media (max-width: 1080px) {
      .ourwork_title {
        font-size: 24px;
      }
      .ourwork_content {
        width: 100%;
        position: relative;
        .ourwork {
          width: calc(50% - 24px);
          .ourwork_img {
            height: 300px;
          }
        }
      }
    }
    @media (max-width: 768px) {
      .ourwork_content {
        .ourwork {
          width: 90%;
          .ourwork_img {
            height: 200px;
          }
        }
      }
    }
  }
  @media (max-width: 1080px) {
    .ourwork_wrapper {
      margin: 40px 0;
      .ourwork_title {
        margin-bottom: 32px;
      }
    }
  }
  .news_banner_wrapper {
    position: relative;
    max-width: 1080px;
    max-height: 500px;
    margin: 0 auto;
    cursor: pointer;
    .news_banner_img_content {
      padding-bottom: calc(100% * (9 / 16));
      min-height: 200px;
      .news_banner_img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 16px;
      }
    }
    .news_banner_tag {
      width: 100%;
      background: rgba(0, 0, 0, 0.75);
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
      color: #ffffff;
      position: absolute;
      bottom: 0;
      border-radius: 16px;
      padding: 28px 40px;
      .title {
        font-size: 24px;
        font-weight: bold;
        line-height: 28px;
      }
      .description {
        margin-top: 16px;
        font-size: 14px;
        font-weight: normal;
        line-height: 28px;
      }
    }
    @media (max-width: 1080px) {
      .news_banner_tag {
        padding: 16px 20px;
        .title {
          font-size: 16px;
        }
        .description {
          margin-top: 12px;
          font-size: 12px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
  @media (max-width: 1080px) {
    .news_banner_wrapper {
      width: 90%;
    }
  }
  .world_vision_wrapper {
    margin: 90px auto;
    width: 1080px;
    .title {
      font-size: 32px;
      font-weight: bold;
      text-align: center;
      line-height: 28px;
      color: #333333;
    }
    .description {
      margin: 24px auto;
      font-size: 14px;
      font-weight: normal;
      line-height: 28px;
      text-align: center;
      color: #666666;
      width: 80%;
    }
    .world_vision_content {
      display: flex;
      justify-content: center;
      gap: 40px;
      margin-top: 100px;
      flex-wrap: wrap;
      .sub_word_vision {
        width: calc(50% - 20px);
      }
      .word_vision {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border-radius: 16px;
        background: #f78335;
        height: 200px;
        position: relative;
        @supports (-webkit-transform-style: preserve-3d) {
          &:hover {
            -webkit-transform: translateY(-2px);
            transform: translateY(-2px);
          }
        }
        &.main {
          background: linear-gradient(160deg, #f78335 3%, #f78335 3%, #1e7bde 87%);
          height: 500px;
        }
        .label {
          font-size: 26px;
          font-weight: bold;
          line-height: 32px;
          letter-spacing: 0px;
          color: #ffd2ae;
          text-align: center;
        }
        .word_vision_img {
          position: absolute;
          top: -50px;
          width: 100px;
          height: 100px;
          background: #ffff;
          border-radius: 50%;
        }
      }
    }
  }
  @media (max-width: 1080px) {
    .world_vision_wrapper {
      margin: 40px 0;
      .world_vision_content {
        margin-top: 72px;
      }
    }
  }
  @media (max-width: 1080px) {
    .world_vision_wrapper {
      width: 100%;
      position: relative;
      padding: 15px;
      .title {
        font-size: 24px;
      }
      .world_vision_content {
        gap: 20px;
        .sub_word_vision {
          width: 90%;
        }
        .word_vision {
          .label {
            font-size: 16px;
            margin-top: 60px;
          }
          &.main {
            height: 200px;
            margin-bottom: 100px;
          }
          @media (max-width: 768px) {
            .label {
              font-size: 18px;
            }
          }
        }
      }
    }
  }
  .news_wrapper {
    margin: 90px auto;
    width: 1080px;
    .title {
      font-size: 32px;
      font-weight: bold;
      text-align: center;
      line-height: 28px;
      margin-bottom: 60px;
      color: #333333;
    }
    .news_content {
      .news {
        width: 100%;
        display: flex;
        margin-bottom: 24px;
        background: #f7f7f7;
        padding: 24px;
        border-radius: 16px;
        cursor: pointer;
        @supports (-webkit-transform-style: preserve-3d) {
          &:hover {
            -webkit-transform: translateY(-2px);
            transform: translateY(-2px);
          }
        }
        .news_img {
          width: 300px;
          height: 180px;
          border-radius: 16px;
          margin-right: 24px;
        }
        .news_info {
          flex: 1;
          position: relative;
          .news_title {
            font-size: 24px;
            font-weight: bold;
            line-height: 28px;
            margin-bottom: 16px;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
          .news_description {
            font-size: 14px;
            font-weight: normal;
            line-height: 20px;
            color: #666666;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 5;
          }
          .more {
            margin-top: 16px;
            display: inline-block;
            font-size: 14px;
            font-weight: normal;
            color: #1e7bde;
            cursor: pointer;
            position: absolute;
            right: 0;
            bottom: 0;
            text-decoration: none;
          }
        }
      }
    }
  }
  @media (max-width: 1080px) {
    .news_wrapper {
      width: 100%;
      position: relative;
      margin: 40px auto;
      .title {
        font-size: 24px;
        margin-bottom: 32px;
      }
      .news_content {
        .news {
          padding: 16px;
          .news_img {
            width: 180px;
            height: auto;
          }
          .news_info {
            .news_title {
              font-size: 14px;
              margin-bottom: 8px;
            }
            .news_description {
              line-height: 20px;
              -webkit-line-clamp: 2;
            }
          }
        }
      }
    }
  }
}
</style>
